module.exports = __webpack_public_path__ + "static/media/takeda-ireland.390ece52.jpg";